import $ from 'jquery';
import { $window } from '../../../Constants';
import { Settings } from '../Settings';
import Transitions from '../Transitions/Transitions';

/**
 * Slide
 *
 * @return Slide
 */
const Slide = (($) => {
  /**
   * Selector
   *
   * @type { Object.<String> }
   */
  const Selector = {
    IMAGE: '.headerslider-slide-image',
    CONTENT: '.headerslider-slide-content',
    CONTENT_INNER: '.headerslider-slide-content-inner',
  };

  /**
   * ClassName
   *
   * @type { Object.<String> }
   */
  const ClassName = {
    VISIBLE: 'visible'
  };

  /**
   * HeaderSlider
   *
   * @class
   */
  class Slide {
    /**
     * @constructor
     *
     * @param { jQuery } $image
     * @param { HeaderSlider } slider
     */
    constructor($image, slider) {
      this._$image = $image;
      this._slider = slider;
      this._uid = this._$image.data('uid');
      this._$content = this._getContent();

      this._transitionImage = new Transitions.FADE(this._$image, Settings.duration);

      if (this._$content) {
        this._transitionContent = new Transitions.FADE(this._$content, Settings.duration);
      }
    }

    // Public

    /**
     * Shows the image & content
     *
     * @param { function } callback
     * @return void
     */
    show(callback = null) {
      this._showImage();
      this._showContent(() => {
        if (typeof callback === 'function') {
          callback();
        }
      });
    }

    /**
     * Hides the image & content
     *
     * @param { function } callback
     * @return void
     */
    hide(callback = null) {
      this._hideImage(() => {
        if (typeof callback === 'function') {
          callback();
        }
      });

      if (this._$content) {
        this._hideContent();
      }
    }

    // Private

    /**
     * Returns the content if available
     *
     * @return { jQuery | null }
     */
    _getContent() {
      let $content = this._slider.$contents.find(`${Selector.CONTENT}[data-uid="${this._uid}"]`);

      if ($content.length) {
        return $content;
      }

      return null;
    }

    /**
     * Shows the image
     *
     * @param { function } callback
     * @return void
     */
    _showImage(callback = null) {
      this._transitionImage.in(() => {
        if (typeof callback === 'function') {
          callback();
        }
      });
    }

    /**
     * Hides the image
     *
     * @param { function } callback
     * @return void
     */
    _hideImage(callback = null) {
      this._transitionImage.out(() => {
        if (typeof callback === 'function') {
          callback();
        }
      });
    }

    /**
     * Shows the content
     *
     * @param { function } callback
     * @return void
     */
    _showContent(callback = null) {
      if (this._$content) {
        this._slider.$content.removeClass('no-content');
        this._slider.$content.append(this._$content);
        this._slider.setContentHeightAndPosition(this._$content.outerHeight());

        this._transitionContent.in(() => {
          if (this._slider.$activeContent) {
            this._slider.$activeContent.remove();
          }

          this._slider.$activeContent = this._$content;

          if (typeof callback === 'function') {
            callback();
          }
        });
      } else {
        if ($window.width() >= Settings.breakpoint) {
          setTimeout(() => {
            this._slider.$content.addClass('no-content');
            this._slider.$activeContent = null;

            if (typeof callback === 'function') {
              callback();
            }
          }, Settings.duration);
        } else {
          this._slider.$content.addClass('no-content');
          this._slider.$activeContent = null;

          setTimeout(() => {
            if (typeof callback === 'function') {
              callback();
            }
          }, Settings.duration);
        }
      }
    }

    /**
     * Hides the content
     *
     * @param { function } callback
     * @return void
     */
    _hideContent(callback = null) {
      this._transitionContent.out(() => {
        if (typeof callback === 'function') {
          callback();
        }
      });
    }

    // Getters

    /**
     * Gets the selector constant
     *
     * @return { Object } Selector
     */
    static get Selector() {
      return Selector;
    }
  }

  return Slide;
})($);

export default Slide;
